import styled from "styled-components";
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
`;

export const QuestaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 24px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const OpcaoContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  ${(props) =>
    props.backgroundColor &&
    `
    background-color: ${props.backgroundColor}
    `}

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const SaveContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;

  & > *:not(:last-child) {
    margin-right: 8px;
  }
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  max-width: 1100px;

  margin: 0px auto 15px auto;
  padding-bottom: 5px;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const ContainerInputSearch = styled.div`
  display: flex;

  width: 100%;
  height: 50px;

  & i {
    height: 75% !important;
  }
`;

export const Input = styled.input`
  width: 90%;
  height: 35px;
  margin-right: 0.3rem;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }
`;

export const Redirect = styled.a`
  color: #2185d0 !important;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: #2d8cd4 !important;
  }
`;

export const TableButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${(props) => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }
`;

export const HorizontalContainer = styled.div`
  display: flex;
`;

export const Fieldset = styled.fieldset`
  border: none;
  margin-bottom: 16px;
  padding: 0;
  display: flex;
  flex-direction: ${(props) => props?.direction || "column"};

  ${(props) =>
    props.direction === "row" &&
    `
  
  > :not(:last-child) {
    margin-right: 16px;
  }

  `}

  ${(props) =>
    props.direction !== "row" &&
    `
  
  > :not(:last-child,:first-child) {
    margin-bottom: 16px;
  }

  `}

${(props) =>
    props.changed &&
    `
  border: 2px solid rgba(0,0,255, 0.5);
  padding: 4px;
`}
`;
